import { connect } from 'react-redux';
import { autobetPause } from '@modules/games/Game/store/gameAutobet/gameAutobet.actions';
import { closeModal } from '@modules/modals/store/modal.actions';
import { setConfirm } from '../../../store/confirm/confirm.actions';
import { appGoTo } from '../../../store/app/app.actions';
import { seedRefreshServer } from '../../../store.async/seed/seed.actions';
import { ServerSeedInput } from './serverSeedInput';

const mapStateToProps = (state) => {
	return {
		value: state.seed && state.seed.serverHashed,
		autobetPaused: state.gameAutobet?.pause,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onClick: () => dispatch(seedRefreshServer()),
		pauseAutobet: (bool) => dispatch(autobetPause(bool)),
		setConfirm: (data) => dispatch(setConfirm(data)),
		goTo: (id, validUrl) => dispatch([closeModal(), appGoTo(id, validUrl)]),
	};
};

const ServerSeedInputContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
)(ServerSeedInput);

export default ServerSeedInputContainer;
